module.exports = __webpack_public_path__ + "img/no-personal-accounts.0a91171.png";